import { defineRecipe } from '@chakra-ui/react';

export const flexRecipe = defineRecipe({
    variants: {
        colorScheme: {
            primary: {
                color: '#000000',

                _hover: {

                },
            },
            variant: {
                color: 'white',

                _hover: {

                },
            },
        },
    },
});
